import React from 'react';

const Services = () => {
    return (
        <div className="container py-4">
            <div className='d-flex justify-content-between flex-wrap'>
                <span className='d-flex mx-auto mx-md-0 '>
                    <span className='d-flex align-items-center'>
                        <svg xmlns="http://www.w3.org/2000/svg" style={{ width: '65px', color: '#FF7700' }} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                            <path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z" />
                        </svg>
                    </span>
                    <span style={{ marginLeft: '3px', fontFamily: 'Poppins', fontSize: '20px', lineHeight: '1', display: 'flex', alignItems: 'center' }}>
                        Selected partners <br />
                        and suppliers
                    </span>
                </span>

                <span className='d-flex mx-auto mx-md-0'>
                    <span className='d-flex align-items-center'>
                        <svg xmlns="http://www.w3.org/2000/svg" style={{ width: '65px', color: '#FF7700' }} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                            <path strokeLinecap="round" strokeLinejoin="round" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                            <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                        </svg>
                    </span>
                    <span style={{ marginLeft: '3px', fontFamily: 'Poppins', fontSize: '20px', lineHeight: '1', display: 'flex', alignItems: 'center' }}>
                        Selected partners <br />
                        and suppliers
                    </span>
                </span>

                <span className='d-flex mx-auto mx-md-0 '>
                    <span className='d-flex align-items-center'>
                        <svg xmlns="http://www.w3.org/2000/svg" style={{ width: '65px', color: '#FF7700' }} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                            <path strokeLinecap="round" strokeLinejoin="round" d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z" />
                        </svg>
                    </span>
                    <span style={{ marginLeft: '3px', fontFamily: 'Poppins', fontSize: '20px', lineHeight: '1', display: 'flex', alignItems: 'center' }}>
                        Free delivery on all <br />
                        orders over $750
                    </span>
                </span>

                <span className='d-flex mx-auto mx-md-0 '>
                    <span className='d-flex align-items-center'>
                        <svg xmlns="http://www.w3.org/2000/svg" style={{ width: '65px', color: '#FF7700' }} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                            <path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                        </svg>
                    </span>
                    <span style={{ marginLeft: '3px', fontFamily: 'Poppins', fontSize: '20px', lineHeight: '1', display: 'flex', alignItems: 'center' }}>
                        Fast and secured <br />
                        payment solutions
                    </span>
                </span>

            </div>
        </div>
    );
};

export default Services;